import { RegisteredItem } from '../../models/registered-item/registered-item.interface';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';
import { mockRegisteredItemProductDetailsAnnual } from './registered-item-product-details-annual.mock';
import { mockRegisteredItemProductDetails } from './registered-item-product-details.mock';

export const mockRegisteredItem: RegisteredItem = {
  appliances: [mockRegistrationApplianceDetails],
  earliestServiceAvailablityDate: '2022-04-25',
  effectiveDate: '2022-04-25',
  endDate: '2022-05-25',
  outOfGuarantee: false,
  Id: '0Q0050000006nsHCAQ',
  merchandiseBrand: 'Amana',
  merchandiseManufacturer: 'Whirlpool',
  merchandiseType: 'Dishwasher',
  numberOfAvailableSlots: '1',
  paymentDescriptor: 'D&G Svc Plan',
  PersonEmail: 'bob.ross@gmail.com',
  personId: '0018G00000P8dgDQAR',
  products: [
    mockRegisteredItemProductDetails,
    mockRegisteredItemProductDetailsAnnual,
  ],
  quoteNumber: 'DGQ0000028586',
  serviceAvailabilityDaysSearched: '1',
  standardPremium: 4.0,
  status: 'Live',
  tax: 0.96,
  totalPrice: 4.96,
};
